import { Switch } from "@/Components/ui/switch";
import PropTypes from 'prop-types';

const StyledSwitch = (props) => {
    const { title, checked, onCheckedChange, id } = props;
    return (
        <div className="flex items-center space-x-2 py-0">
            <Switch
                checked={checked}
                onCheckedChange={onCheckedChange}
                id={id}
                // We verwijderen de custom styling en laten shadcn/ui's styling intact
                className="bg-gray-200 data-[state=checked]:bg-ps-green [&>span]:bg-white"
            />
            <label
                htmlFor={id}
                className="font-inter text-sm text-ps-blue-dark cursor-pointer"
            >
                {title}
            </label>
        </div>
    );
};

StyledSwitch.propTypes = {
    checked: PropTypes.bool.isRequired,
    onCheckedChange: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired
};

export default StyledSwitch;